"use client";
import SectionWrapper from "@cc/section-wrapper";
import { Body1, H1, H6_3 } from "@theme/components/typography.fontvariant";
import { Typography } from "@mui/material";
import { MaterialImage } from "@cc/material-components";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { StaticImageData } from "next/image";
import Link from "@cc/link";

export type HowWeHelpProps = {
  data: {
    title: string;
    description: string;
    howWeHelpData: {
      image: StaticImageData | string;
      tag: string;
      description: string;
      href: string;
    }[];
  };
  navId?: string;
};

const HowWeHelp = (props: HowWeHelpProps) => {
  const { title, description, howWeHelpData } = props.data;
  return (
    <SectionWrapper
      color={"secondary.main"}
      SectionProps={{
        sx: {
          background: (theme) => theme.palette.gradient.darkToLight,
        },
      }}
      navId={props.navId || "our-ideas"}
      SectionHeaderProps={{
        title: title,
        TitleTypographyProps: {
          variant: "h3",
          fontSize: H1,
          width: { xs: 1, md: "calc(100vw - 310px)" },
          maxWidth: 1130,
        },
        description: description,
        DescriptionTypographyProps: {
          fontSize: Body1,
        },
        isArrow: true,
        isArrowWrapperProps: {
          alignItems: "center",
          columnGap: 0,
        },
        ArrowProps: {
          width: 69,
          height: 176,
        },
      }}
    >
      <Grid2 container rowSpacing={5} columnSpacing={{ xs: 2, sm: 3 }}>
        {howWeHelpData.map((data, index) => {
          const { image, tag, description, href = "/" } = data;
          return (
            <Grid2 key={index} md={6}>
              <Link
                href={href}
                style={{
                  textDecoration: "none",
                  display: "flex",
                  flexDirection: "column",
                  rowGap: 16,
                }}
              >
                <MaterialImage
                  src={image}
                  width={644}
                  height={310}
                  sx={{
                    width: "100%",
                    height: "auto",
                    maxHeight: 310,
                    minHeight: { xs: 200, md: 255, xl: 310 },
                    objectFit: "cover",
                  }}
                  alt={tag}
                />
                <Typography
                  variant={"caption"}
                  sx={{
                    bgcolor: "secondary.400",
                    width: "fit-content",
                    color: "grey.600",
                    p: 0.75,
                  }}
                >
                  {tag}
                </Typography>
                <Typography fontSize={H6_3}>{description}</Typography>
              </Link>
            </Grid2>
          );
        })}
      </Grid2>
    </SectionWrapper>
  );
};

export default HowWeHelp;
